import { createAsyncThunk } from '@reduxjs/toolkit'
import System from './system-model'
import { delete_system, load_systems, store_system } from './system-service'

export const LoadSystemsAsync = createAsyncThunk<any, any>(
  'composer/load/system',
  async (params: { uid: string }) => {
    return await load_systems(params)
  },
)

export const CreateSystemAsync = createAsyncThunk<any, any>(
  'composer/create/system',
  async (params: System) => {
    return await store_system(params)
  },
)

export const DeleteSystemAsync = createAsyncThunk<any, any>(
  'composer/delete/system',
  async (params) => {
    return await delete_system(params)
  },
)
